import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"
import axios from "axios"

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getCommands = async (token, options = {}) => {
    log("welcome in getCommands")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (options.imsi_value) params.imsi_value = options.imsi_value
        if (options.msisdn_value) params.msisdn_value = options.msisdn_value
        if (options.sim_id) params.sim_id = options.sim_id
        if (options.client_id) params.client_id = options.client_id
        if (options.command_status_id) params.command_status_id = options.command_status_id
        if (options.provision_action_id) params.provision_action_id = options.provision_action_id
        if (options.provision_use_case_id) params.provision_use_case_id = options.provision_use_case_id
        if (options.search_term) params.search_term = options.search_term
        if (options.date_from) params.date_from = options.date_from
        if (options.date_to) params.date_to = options.date_to
        if (options.page) params.page = options.page
        if (options.per_page) params.per_page = options.per_page

        const result = await axios.get(BASE_URL + '/home/getCommandsApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getCommands", err)
        return { error: true, message: "Error loading commands" }
    }
}

export const getCommandDetails = async (token, commandId) => {
    log("welcome in getCommandDetails")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommandDetailsApi', {
            headers: getHeaders(token),
            params: { command_id: commandId }
        })
        return result.data
    } catch (err) {
        log("Error in getCommandDetails", err)
        return { error: true, message: "Error loading command details" }
    }
}

export const getCommandFilters = async (token) => {
    log("welcome in getCommandFilters")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommandFiltersApi', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getCommandFilters", err)
        return { error: true, message: "Error loading command filters" }
    }
}

export const createCommand = async (token, data) => {
    log("welcome in createCommand")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/createCommandApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in createCommand", err)
        return { error: true, message: "Error creating command" }
    }
}

export const updateCommand = async (token, data) => {
    log("welcome in updateCommand")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.put(BASE_URL + '/home/updateCommandApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in updateCommand", err)
        return { error: true, message: "Error updating command" }
    }
}

export const deleteCommand = async (token, commandId) => {
    log("welcome in deleteCommand")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.delete(BASE_URL + '/home/deleteCommandApi', {
            headers: getHeaders(token),
            params: { command_id: commandId }
        })
        return result.data
    } catch (err) {
        log("Error in deleteCommand", err)
        return { error: true, message: "Error deleting command" }
    }
}

export default {
    getCommands,
    getCommandDetails,
    getCommandFilters,
    createCommand,
    updateCommand,
    deleteCommand
}
